import { useEffect, useState } from "react";
import { toast } from "sonner";
import { LockOpen, Wallet } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";

export default function AbrirCajaDialog({ open, onClose, caja, sucursalId, fondoSugerido = 0, ultimoCorte, onAbierta }) {
  const [fondo, setFondo] = useState("");
  const [nota, setNota] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => { if (open) { setFondo(String(fondoSugerido ?? 0)); setNota(""); } }, [open, fondoSugerido]);

  async function abrir(e) {
    e.preventDefault();
    setGuardando(true);
    try {
      const { data } = await api.post("/cajas/abrir", { caja, sucursal_id: sucursalId || undefined, fondo_inicial: parseFloat(fondo) || 0, nota: nota || null });
      toast.success(`${caja} abierta con fondo de $${data.fondo_inicial.toFixed(2)}`);
      onAbierta?.(data);
      onClose();
    } catch (err) { toast.error(formatApiError(err)); } finally { setGuardando(false); }
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="abrir-caja-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl font-bold flex items-center gap-2"><LockOpen className="w-5 h-5 text-brand-amber" /> Abrir {caja}</DialogTitle></DialogHeader>
        <form onSubmit={abrir} className="space-y-4">
          <div className="rounded-2xl bg-brand-canvas p-4">
            <label className="eyebrow flex items-center gap-1"><Wallet className="w-3.5 h-3.5" /> Fondo inicial en efectivo</label>
            <div className="flex items-center gap-2 mt-2"><span className="font-display font-extrabold text-2xl text-brand-ink">$</span><input data-testid="abrir-caja-fondo-input" type="number" min="0" step="0.01" value={fondo} onChange={(e) => setFondo(e.target.value)} className="field h-12 text-2xl font-mono font-bold" autoFocus required /></div>
            <p className="text-[11px] text-brand-muted mt-2" data-testid="abrir-caja-sugerido">
              {ultimoCorte ? <>Prellenado con el efectivo que quedó en el corte <b className="font-mono">{ultimoCorte.folio}</b> (${Number(fondoSugerido || 0).toFixed(2)}). Ajusta si el conteo físico es distinto.</> : "Sin cortes previos en esta caja: captura el efectivo con el que inicias."}
            </p>
          </div>
          <input data-testid="abrir-caja-nota-input" value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Nota (opcional)" className="field" />
          <button data-testid="abrir-caja-confirmar" type="submit" disabled={guardando} className="btn-amber w-full h-12"><LockOpen className="w-4 h-4" /> {guardando ? "Abriendo…" : "Abrir caja y empezar turno"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
